const NO_LOCATION = /^none(\s*\(.*\))?$/i;

const REASON_LABELS = {
    'no-evidence': 'no cell or Wi-Fi data',
    'lookup-disallowed': 'too old to look up',
    'lookup-failed': 'lookup failed',
    'speed-check': 'failed speed check',
    'fallback-rejected': 'gateway position rejected',
    'manual': 'removed by operator'
};

// The API reports a missing fix as "None" (older rows "None (Low battery)"); when it also says why,
// show that instead of a battery hint the row never carried: "None (lookup failed)".
export function formatLocationMethod(locationMethod, noLocationReason) {
    const method = (locationMethod && locationMethod !== '') ? locationMethod : 'None';
    if (noLocationReason && NO_LOCATION.test(method)) {
        const label = REASON_LABELS[noLocationReason] || String(noLocationReason).replace(/-/g, ' ');
        return 'None (' + label + ')';
    }
    return method;
}

// True for any "None" label, raw or formatted, so icon and grouping checks never compare against display text.
export function hasNoLocation(locationMethod) {
    return !locationMethod || NO_LOCATION.test(locationMethod);
}
